import { ConnectedOverlayPositionChange, ConnectedPosition } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { includes, orderBy } from 'lodash-es';

export type NimbusCdkArrowCssClass =
  | 'right-top'
  | 'right-center'
  | 'right-bottom'
  | 'left-top'
  | 'left-center'
  | 'left-bottom'
  | 'top-center'
  | 'bottom-center';

@Injectable({ providedIn: 'root' })
export class NimbusTooltipService {
  public getCdkConnectedPositions(preferredCssClasses: NimbusCdkArrowCssClass[] = null): ConnectedPosition[] {
    const items: ConnectedPosition[] = [
      { panelClass: 'right-top', originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'top', offsetX: 10, offsetY: -32 },
      { panelClass: 'right-center', originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'center', offsetX: 10 },
      { panelClass: 'right-bottom', originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'bottom', offsetX: 10, offsetY: 32 },
      { panelClass: 'left-top', originX: 'start', originY: 'center', overlayX: 'end', overlayY: 'top', offsetX: -10, offsetY: -32 },
      { panelClass: 'left-center', originX: 'start', originY: 'center', overlayX: 'end', overlayY: 'center', offsetX: -10 },
      { panelClass: 'left-bottom', originX: 'start', originY: 'center', overlayX: 'end', overlayY: 'bottom', offsetX: -10, offsetY: 32 },
      { panelClass: 'top-center', originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetX: 0, offsetY: -10 },
      { panelClass: 'bottom-center', originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetX: 0, offsetY: 10 },
    ];
    return preferredCssClasses && preferredCssClasses.length
      ? orderBy(items, (x) => (includes(preferredCssClasses, x.panelClass) ? -1 : 1))
      : items;
  }

  public getCdkArrowCssClass(e: ConnectedOverlayPositionChange = null): string {
    return e && e.connectionPair ? (e.connectionPair.panelClass as NimbusCdkArrowCssClass) : '';
  }
}
